import React from "react";
import styled from "styled-components";

import HeaderImage from "../../assets/img/home/home.jpg";
import ImgGallery1 from "../../assets/img/home/gallery1.jpg";
import ImgGallery2 from "../../assets/img/home/gallery2.jpg";
import ImgGallery3 from "../../assets/img/home/gallery3.jpg";
import ImgGallery4 from "../../assets/img/home/gallery4.jpg";
import ImgGallery5 from "../../assets/img/home/gallery5.jpg";
import ImgGallery6 from "../../assets/img/home/gallery6.jpg";
// import ImgGallery7 from "../../assets/img/home/gallery7.jpg";
export default function Header() {
  return (
    <Wrapper id="home" className="container flexSpaceCenter">
      {/*<LeftSide className="flexCenter">*/}
      {/*    <div>*/}
      {/*        <h1 className="extraBold font60 ">Willkommen bei Ihrem Teppichhaus in Böblingen</h1>*/}
      {/*        <HeaderP className="font18 semiBold">*/}
      {/*            Entdecken Sie hochwertige Teppiche für jeden Raum und Stil. Wir bieten Ihnen eine große Auswahl an Teppichen, die Gemütlichkeit und Eleganz in Ihr Zuhause bringen.*/}
      {/*        </HeaderP>*/}
      {/*    </div>*/}
      {/*</LeftSide>*/}
      {/*<RightSide>*/}
      {/*    <Img className="radius8" src={HeaderImage} alt="office" style={{ width: "100%", maxWidth: "600px", zIndex: 9 }} />*/}
      {/*</RightSide>*/}
        {/* Welcome + Shop Front */}
        <Section>
            <h2 className="font30 extraBold">Willkommen in Ihrem Teppichhaus in Böblingen</h2>

            <ImgFull src={HeaderImage} alt="Teppichhaus Hosseinzadeh" />
            {/*<p className="font18">*/}
            {/*    Die Hosseinzadeh Qualität bedeutet beste Wollqualität, Naturfarbe, Tradition, Ästhetik,*/}
            {/*    Variationen in Farben und Muster. Teppiche für die Zukunft.*/}
            {/*</p>*/}
            <HeaderP className="font18 semiBold">
                Die Hosseinzadeh Qualität bedeutet beste Wollqualität, Naturfarbe, Tradition, Ästhetik,
                Variationen in Farben und Muster. Teppiche für die Zukunft. Entdecken Sie hochwertige
                Teppiche für jeden Raum und Stil. Wir bieten Ihnen eine große Auswahl an Teppichen, die
                Gemütlichkeit und Eleganz in Ihr Zuhause bringen.            </HeaderP>
            <GalleryGrid>
                <img src={ImgGallery1} alt="Teppichgalerie 1" />
                <img src={ImgGallery2} alt="Teppichgalerie 2" />
                <img src={ImgGallery3} alt="Teppichgalerie 3" />
                <img src={ImgGallery4} alt="Teppichgalerie 4" />
                <img src={ImgGallery5} alt="Teppichgalerie 5" />
                <img src={ImgGallery6} alt="Teppichgalerie 6" />
            </GalleryGrid>
            {/*<p className="font18">*/}
            {/*    <strong>Adresse:</strong> Orientteppich Hosseinzadeh, Sindelfinger Straße 11, 71032 Böblingen<br />*/}
            {/*    <strong>Öffnungszeiten:</strong> Montag bis Freitag 10–18:00 Uhr · Samstag 9–14 Uhr<br />*/}
            {/*    <strong>Telefon:</strong> 07031-224724*/}
            {/*</p>*/}
        </Section>
    </Wrapper>
  );
}
const Section = styled.div`
  //margin-bottom: 10px;
  text-align: center;
`;

const Wrapper = styled.section`
  
  padding-top: 85px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 960px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-bottom: 10px;

  }
`;


const HeaderP = styled.div`
  padding: 5px 0 5px 0;
  line-height: 1.5rem;
  @media (max-width: 960px) {
    padding: 15px 0 20px 0;
    text-align: center;
    max-width: 100%;
  }
`;


const ImgFull = styled.img`
  width: 100%;
  //max-height: 500px;
  object-fit: cover;
  border-radius: 1rem;
`;

const GalleryGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  margin: 20px 0;

  img {
    width: 280px;
    height: auto;
    border-radius: 1rem;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    img {
      width: 90%;
    }
  }
`;


